module.exports = __webpack_public_path__ + "img/20200319110022228.d4ef9f12.png";